<p-ai-chat-window-messages
    [chatMessages]="(conversation.messages | async)!"
    [assistantThinking]="(conversation.assistantThinking | async)!"
    [assistantWorking]="(conversation.assistantWorking | async)!"
    [assistantSilent]="(conversation.assistantSilent | async)!"
    [linkPrefix]="conversation.sourceLink"
    [suggestions]="suggestionsProvider.suggestions$ | async"
    [suggestionsFetchTrigger$]="suggestionsFetchService.trigger$"
    [thinkingEvent]="(thinking.thinking$ | async)!"
></p-ai-chat-window-messages>
